import React from "react";
import locale from "antd/es/date-picker/locale/zh_CN";
import { Radio, TimePicker, Input, Button, Select, message } from 'antd';
import './index.sass'
import api from "../../../../utils/api";
import moment from "moment";

const { Option } = Select;

export default class AddTiming extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            order_type: 0,
            logistics_type: 'self_pick',
            collect_type: 1,
            select_date_type: 1,
            every_time: '00:00',
            summary_delay: '0',
            summary_time: '00:00-23:59',
            remark: '',
            weeks: [
                { val: 1, name: '周一' },
                { val: 2, name: '周二' },
                { val: 3, name: '周三' },
                { val: 4, name: '周四' },
                { val: 5, name: '周五' },
                { val: 6, name: '周六' },
                { val: 7, name: '周日' },
            ],
            months: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
            ],
            seeDetail: this.props.seeDetail
        }
    }

    componentDidMount() {
        console.log(this.props, '99999999999999')
        this.getOldData();
    }

    getOldData() {
        let { seeDetail } = this.props;
        if (seeDetail) {
            this.setState({
                order_type: seeDetail['order_type'],
                remark: seeDetail['remark'],
                collect_type: seeDetail['summary_type'],
                every_time: seeDetail['summary_rule']['summary_at'],
                summary_time: seeDetail['summary_rule']['summary_time'],
                summary_delay: seeDetail['summary_rule']['summary_delay']
            })

        }
    }

    orderType = (e) => {
        console.log(e)
        this.setState({
            order_type: e.target.value
        })
    }

    logisticsType = (e) => {
        this.setState({
            logistics_type: e.target.value
        })
    }

    collectType = (e, k) => {

        let { summary_delay } = this.state

        this.setState({
            collect_type: e.target.value,
            summary_delay: e.target.value === 1 ? 0 : summary_delay
        })

        // console.log(e, k, 'collectType')

    }

    selectDateType = (e) => {

        this.setState({
            select_date_type: e.target.value
        })

    }

    weeksChange = () => { }

    monthsChange = () => { }

    closeHandle = () => {
        this.props.colsePop({ show: false })
    }

    selectWhatDay = (e) => {//第几天

        console.log(e)

        this.setState({
            summary_delay: e
        })


    }


    addTask = async () => {//添加定时任务
        let { order_type, logistics_type, collect_type, every_time, summary_time, remark, summary_delay } = this.state;
        let param = {
            condition: {
                order_type,
                delivery_type: logistics_type
            },
            task_info: {
                summary_type: collect_type,
                summary_rule: {
                    summary_at: every_time,
                    summary_delay,
                    summary_time
                },
            },

            remark
        }

        let res = await api('add-task', param);

        if (res.code === 200) {
            message.success(res.message)

            this.props.upList(true)
        } else {
            message.error(res.message)

        }
    }

    render() {

        let { order_type, logistics_type, collect_type, every_time, seeDetail, summary_time, summary_delay, remark } = this.state;
        return (
            <div className='addTiming'>
                <div className='close'></div>

                <div className='popBox'>
                    <p className='title'>
                        添加配送单定时任务
                    </p>

                    <div className='popContent'>
                        <div className='popCtx'>

                            <div className='flex line alignCenter'>

                                <label>汇总订单类型：</label>

                                <Radio.Group onChange={(e) => { this.orderType(e) }} value={order_type}>
                                    <Radio value={0}>全部订单</Radio>
                                    <Radio value={11}>合约订单</Radio>
                                    <Radio value={10}>团购订单</Radio>
                                    <Radio value={20}>商城订单</Radio>
                                </Radio.Group>


                            </div>

                            <div className='flex line alignCenter'>
                                <label>选择物流类型：</label>

                                <Radio.Group onChange={(e) => { this.logisticsType(e) }} value={logistics_type}>
                                    <Radio value={'self_pick'}>自配送</Radio>
                                    <Radio value={''} disabled>快递</Radio>
                                </Radio.Group>
                            </div>

                            <div className='flex line alignCenter'>
                                <label>汇总方式：</label>

                                <Radio.Group onChange={(e) => { this.collectType(e) }} value={collect_type}>
                                    <Radio value={1}>按到货时间汇总</Radio>
                                    {
                                        order_type !== 4 ? (
                                            <Radio value={2}>按截单时间汇总</Radio>
                                        ) : null
                                    }

                                    <Radio value={3}>按订单时间汇总</Radio>
                                </Radio.Group>
                            </div>


                            <div className='flex line alignCenter'>
                                <label></label>
                                <div className='flex line alignCenter'>
                                    每天&nbsp; <TimePicker value={moment(every_time, 'HH:mm')} className='width100' onChange={(e, d) => { this.setState({ every_time: d }) }} locale={locale} format={'HH:mm'} />&nbsp;，
                                    汇总&nbsp;

                                    {
                                        collect_type === 2 ? (
                                            <> 前 <TimePicker value={moment(summary_delay, 'HH')} className='width100' onChange={(e, d) => { console.log(e, d); this.setState({ summary_delay: d }) }} locale={locale} format={'HH'} />
                                                个小时 </>) : null
                                    }

                                    {
                                        collect_type !== 2 ? (
                                            <Select value={summary_delay} className='width100' onChange={(e) => { this.selectWhatDay(e) }}>
                                                <Option value="0">当日</Option>
                                                <Option value="1">第二天</Option>
                                                <Option value="2">第三天</Option>
                                                <Option value="3">第四天</Option>
                                                <Option value="4">第五天</Option>
                                                <Option value="5">第六天</Option>
                                                <Option value="6">第七天</Option>
                                            </Select>
                                        ) : null
                                    }

                                    &nbsp;
                                    {
                                        collect_type !== 2 ? (
                                            <TimePicker.RangePicker value={[moment(summary_time.split('-')[0], 'HH:mm'), moment(summary_time.split('-')[1], 'HH:mm')]} format={'HH:mm'} locale={locale} onChange={(e, d) => { this.setState({ summary_time: d.join('-') }) }} />
                                        ) : null
                                    }
                                    &nbsp;

                                    {
                                        collect_type === 1 ? ('到货的订单') : collect_type === 2 ? ('所有截单的订单') : collect_type === 3 ? ('所有下单的订单') : null
                                    }



                                </div>
                            </div>
                            <div className='flex line'>
                                <label>添加备注：</label>
                                <Input.TextArea value={remark} placeholder='请输入' onChange={(e) => { this.setState({ remark: e.target.value }) }} />
                            </div>


                            <div className='flex line contrlBtn'>
                                {
                                    !seeDetail ? (
                                        <Button className='themeBtn mgr40' onClick={() => { this.addTask() }}>确定</Button>

                                    ) : null
                                }
                                <Button onClick={() => { this.closeHandle() }}>取消</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}